module.exports = __webpack_public_path__ + "img/icon_pool.42fdc8cf.svg";